export default __webpack_public_path__ + "static/media/ic-safe.1628553a.svg";